<template>
  <div
    v-show="showSubNav"
    class="
      absolute inset-x-0 top-full flex max-h-[calc(100vh-var(--navbar-height)-5rem)] flex-col gap-2
      overflow-y-auto py-3
    "
  >
    <Container use-full-width>
      <!-- LEVEL 2 -->
      <AnimatedContainer ref="animContainer" :delay="0.3">
        <ul class="fade-in grid grid-wrap gap-x-12 divide-grey-200">
          <li v-for="item in children" :key="item.page.id" class="py-10">
            <div class="">
              <NuxtLink
                :to="item.page.url"
                :target="$useIsExternalUrl(item.page.url) ? '_blank' : '_self'"
                class="font-semibold transition-colors ease-in-out typo-body hover:text-primary-900"
                @focus="emit('has-focus-within', true)"
                @blur="emit('has-focus-within', false)"
                @keydown.space.prevent="emit('has-focus-within', false)"
              >
                {{ item.page.title }}
              </NuxtLink>
            </div>

            <!-- LEVEL 3 -->
            <ul class="mt-6 space-y-3">
              <li v-for="child in item.children" :key="child.page.id">
                <NuxtLink
                  :to="child.page.url"
                  :target="$useIsExternalUrl(child.page.url) ? '_blank' : '_self'"
                  class="transition-colors ease-in-out hover:text-primary-900"
                  @focus="emit('has-focus-within', true)"
                  @blur="emit('has-focus-within', false)"
                  @keydown.space.prevent="emit('has-focus-within', false)"
                >
                  {{ child.page.title }}
                </NuxtLink>
              </li>
            </ul>
          </li>
        </ul>
      </AnimatedContainer>
    </Container>
  </div>
</template>

<script lang="ts" setup>
// Define the type for a single navigation node
type NavigationNode = {
  page: {
    id: string
    title: string
    url: string
    external: boolean
  }
  children?: NavigationNode[]
}

const props = defineProps<{
  show: boolean
  hide: boolean
  children: NavigationNode[]
}>()

const emit = defineEmits(['has-focus-within'])

const animContainer = ref<any>(null)

const showSubNav = ref(false)
let leaveTimeout: any = null

// Watch for changes in the show prop
watchEffect(async () => {
  if (props.show) {
    if (leaveTimeout !== null) {
      clearTimeout(leaveTimeout)
      leaveTimeout = null
    }

    showSubNav.value = true
    animContainer.value?.RestartAnimation()
  } else {
    animContainer.value?.ReverseAnimation()

    if (leaveTimeout === null) {
      // hide true means close the nav (animate fast)
      // hide false means just to switch content (animate normal)
      leaveTimeout = setTimeout(() => {
        showSubNav.value = false
      }, props.hide ? 100 : 400)
    }
  }
})
</script>

<style scoped>
.grid-wrap {
  grid-template-columns: repeat(auto-fit, 20rem);
}
</style>
